<template>
  <v-footer height="auto" class="footerstyle" style="margin-top:-20px !important;">
    <v-container fluid class="p-l-0 p-t-0 mt-0" style="padding:0px !important;">
      <div class="footerConsult">
        <v-container fluid>
          <v-layout align-center column justify-center>
            <v-flex xs12 align-center text-lg-center style="padding-top:100px;">
              <h1
                class="display-1 mt-0 metropolisBold font-weight-bold pb-4"
                id="contact-form-header"
              >
                <v-icon
                  v-if="formTitle.icon_status"
                  x-large
                  :color="formTitle.icon_color"
                >{{formTitle.icon_name}}</v-icon>
                {{formTitle.header}}
              </h1>
              <p class="mb-0 headline metropolisMedium pb-4">{{formTitle.text}}</p>
            </v-flex>
            <v-flex>
              <Contact :formTitle="formTitle"></Contact>
            </v-flex>
          </v-layout>
        </v-container>
      </div>

      <v-layout row wrap class="justify-center fBG">
        <v-flex xs12 sm6 md4 lg4 order-md1 order-sm1>
          <v-card tile flat class="white--text">
            <v-card-text>
              <h4 class="metropolisBold text-uppercase mb-2 footerH1">About Us</h4>
              <br />
              <p>{{aboutUs}}</p>

              <!-- <router-link :to="{name: 'career'}">
                <h3 class="font-weight-regular deep-white--text">Check Current Openings</h3>
              </router-link>-->
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md3 lg2 order-md2 order-sm2>
          <v-card tile flat class="white--text">
            <v-card-text>
              <h4 class="metropolisBold text-uppercase mb-2 footerH1">Links</h4>
              <br />
              <v-layout row wrap>
                <v-flex xs1 pb-2>
                  <v-card flat class="white--text">
                    <v-card-text class="px-0 pb-0 pt-0 text-lg-left">
                      <v-icon class="subheading hoveredBlue" color="white lighten-2">navigate_next</v-icon>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs11 pb-2>
                  <v-card flat class="white--text">
                    <v-card-text class="px-0 pb-0 pt-0">
                      <router-link :to="{name:'development'}" class="white--text hoveredBlue">
                        <h3 class="body-1">Development</h3>
                      </router-link>
                    </v-card-text>
                  </v-card>
                </v-flex>

                <v-flex xs1 pb-2>
                  <v-card flat class="white--text">
                    <v-card-text class="px-0 pb-0 pt-0 text-lg-left">
                      <v-icon class="subheading hoveredBlue" color="white lighten-2">navigate_next</v-icon>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs11 pb-2>
                  <v-card flat class="white--text">
                    <v-card-text class="px-0 pb-0 pt-0">
                     <router-link :to="{name:'Portfolio'}" class="white--text hoveredBlue">
                        <h3 class="body-1">Portfolio</h3>
                      </router-link>
                    </v-card-text>
                  </v-card>
                </v-flex>

                <v-flex xs1 pb-2>
                  <v-card flat class="white--text">
                    <v-card-text class="px-0 pb-0 pt-0 text-lg-left">
                      <v-icon class="subheading hoveredBlue" color="white lighten-2">navigate_next</v-icon>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs11 pb-2>
                  <v-card flat class="white--text ">
                    <v-card-text class="px-0 pb-0 pt-0">
                      <router-link :to="{name:'pricing'}" class="white--text hoveredBlue">
                        <h3 class="body-1">Pricing</h3>
                      </router-link>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 sm6 md3 lg2 order-md4 order-sm3>
          <v-card tile flat class="white--text">
            <v-card-text>
              <h4 class="metropolisBold text-uppercase mb-2 footerH1">Contact</h4>
              <br />
              <v-layout row wrap>
                <v-flex xs1 pb-2>
                  <v-card flat class="white--text">
                    <v-card-text class="px-0 pb-0 pt-0 text-lg-left">
                      <v-icon class="subheading" color="white lighten-2">email</v-icon>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs11 pb-2>
                  <v-card flat class="white--text">
                    <v-card-text class="px-0 pb-0 pt-0">
                      <h3 class="body-1"><a href="mailto:hello@canvasdevelopment.com" class="white--text hoveredBlue">hello@canvasdevelopment.com</a></h3>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs1 pb-2>
                  <v-card flat class="white--text">
                    <v-card-text class="px-0 pb-0 pt-0 text-lg-left">
                      <v-icon class="subheading" color="white lighten-2">phone</v-icon>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs11 pb-2>
                  <v-card flat class="white--text">
                    <v-card-text class="px-0 pb-0 pt-0">
                      <h3 class="body-1"><a href="tel:+1 859 684 0646" class="white--text hoveredBlue">+1 859 684 0646</a></h3>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs1 pb-2>
                  <v-card flat class="white--text">
                    <v-card-text class="px-0 pb-0 pt-0 text-lg-left">
                      <v-icon class="subheading" color="white lighten-2">location_on</v-icon>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs11 pb-2>
                  <v-card flat class="white--text">
                    <v-card-text class="px-0 pb-0 pt-0">
                      <h3 class="body-1">1872 Plaudit Place, Lexington, KY 40509</h3>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row wrap class="justify-center footer-bottom">
        <v-flex xs12 sm6 md6 lg6 order-md1 order-sm1>
          <v-card tile flat color="#f5f5f5">
            <v-card-text class="pb-3">
              <div
                class="text-lg-left text-md-left text-sm-left text-xs-center"
              >© 2020 - All Rights Reserved. Canvas Development</div>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 sm4 md4 lg3 order-md3 order-sm4>
          <v-card tile flat>
            <v-card-text style="padding-top:7px;">
              <div class="text-lg-right text-md-right text-sm-right text-xs-center">
                <!-- <a href="#" class="fa fa-facebook"></a>
                <a href="#" class="fa fa-twitter"></a>
                <a href="#" class="fa fa-linkedin"></a>
                <a href="#" class="fa fa-instagram"></a>-->
                <!-- <a href="#" class="fa fa-youtube"></a>
                <a href="#" class="fa fa-vimeo"></a>
                <a href="#" class="fa fa-google"></a>-->
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-footer>
</template>


<script>
import Contact from "@/views/Development/form/contact_form.vue";
export default {
  components: {
    Contact
  },
  data() {
    return {
      aboutUs:
        "Started in 2006, Canvas Development has grown from 1 developer to 12 with 100s of successfully completed projects. One word to describe us would be flexible. We work with our clients, whether you want to pay monthly, weekly, whether you want part time, full time, or a whole team, we can accommodate your needs, and we’re happy to do it.",
      formTitle: {
        header: "What can we get started for you?",
        text:
          "Give us some information, we’ll email or call you within the hour.",
        icon_name: "",
        icon_status: false,
        icon_color: ""
      }
    };
  }
};
</script> 


<style>
.v-list__tile {
  margin: 0;
  font-size: 12px;
  height: 35px;
  padding: 0px;
}

.v-list__group__header__append-icon {
  display: none;
}

a {
  text-decoration: none;
  color: #000;
}

.hoveredBlue:hover{
  color:#1976d2 !important;
}

@media (min-width: 1264px) {
  .flex.lg3 {
    max-width: 22%;
  }
}

.footer-bottom {
  border-top: 1px solid #ccc;
}

.fa {
  padding: 8px;
  font-size: 18px;
  width: 30px;
  text-align: center;
  text-decoration: none;
  margin: 5px 2px;
  border-radius: 20px;
}

.fa:hover {
  opacity: 0.7;
}

.fa-facebook {
  color: #121212;
}

.fa-twitter {
  color: #121212;
}

.fa-google {
  background: #dd4b39;
  color: #121212;
}

.fa-linkedin {
  color: #121212;
}

.fa-youtube {
  background: #bb0000;
  color: white;
}

.fa-instagram {
  color: #121212;
}

.fa-vimeo {
  background: #45bbff;
  color: white;
}

.footerConsult {
  background: rgba(48, 48, 137) url("https://ik.imagekit.io/canvasdev/431001232-72_XNznpflC_j.jpg") no-repeat;
  background-position: center;
  background-size: cover;
  padding: 100px 0;
  color: #fff;
}

.footerH1 {
  font-size: 18px;
}
.fBG {
  background: #121212;
  padding-top: 50px;
  padding-bottom: 50px;
}
</style>
